import getCorePersonalStore from "../../../../../../../stores/core/core-personal-store";
import getUserAdvancedStore from "../../../../../../../stores/user-store/advanced-store";
import { TDescriptionType } from "../../../../../../../Types";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import {
  SURFACE_RADIUS_CSS,
  SURFACE_SHADOW
} from "../../../../../../../core/et3-theme/surface-constants";
import DescriptionDataSolve from "../data-actions/DescriptionSolve";
import DescriptionBody from "./DescriptionBody";
import DescriptionHeader from "./DescriptionHeader";
import {
  DESCRIPTION_SOFT_APPROVED,
  DESCRIPTION_SOFT_PENDING,
  DESCRIPTION_SOFT_REJECTED,
  DESCRIPTION_BOX_HEIGHT,
  DESCRIPTION_COLUMN_HEIGHT,
  DESCRIPTION_WIDTH
} from "./descriptions-constants";

const Description = withLiteObserverAndTheme<{
  userID: number;
  userUUID: string;
  descriptionId: number;
  descriptionStatus: string;
  descriptionType: TDescriptionType;
  description: string;
  descriptionAlignment: "left" | "right";
  isGeneratedByAi: number;
}>((props) => {
  const {
    theme,
    userID,
    userUUID,
    descriptionId,
    descriptionStatus,
    descriptionType,
    description,
    descriptionAlignment,
    isGeneratedByAi
  } = props;
  const { colors } = theme;
  const isPendingDescription = descriptionStatus === "PENDING";
  const isAcceptedDescription = descriptionStatus === "APPROVED";
  const statusBackgroundColor = isPendingDescription
    ? DESCRIPTION_SOFT_PENDING
    : isAcceptedDescription
      ? DESCRIPTION_SOFT_APPROVED
      : DESCRIPTION_SOFT_REJECTED;
  const descriptionBorderColor = isPendingDescription
    ? colors.all.davysGrey
    : isAcceptedDescription
      ? colors.all.seaGreen
      : colors.all.red;
  const isUserDeleted = getUserAdvancedStore().isUserStatusDeleted.get();
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const canSolveDescription = !isUserDeleted && !isAnyKhattabaAdmin;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={DESCRIPTION_WIDTH}
      height={DESCRIPTION_COLUMN_HEIGHT}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={DESCRIPTION_WIDTH}
        height={DESCRIPTION_BOX_HEIGHT}
        color={colors.all.white}
        style={{
          boxSizing: "border-box",
          borderRadius: SURFACE_RADIUS_CSS,
          border: `1px solid ${descriptionBorderColor}`,
          boxShadow: SURFACE_SHADOW
        }}
        onClick={() => {}}
      >
        <DescriptionHeader
          descriptionType={descriptionType}
          isGeneratedByAi={isGeneratedByAi}
          descriptionStatus={descriptionStatus}
          description={description}
          statusToneColor={descriptionBorderColor}
          statusBackgroundColor={statusBackgroundColor}
        />
        <DescriptionBody
          description={description}
          descriptionAlignment={descriptionAlignment}
        />
      </ET3Div>
      {canSolveDescription ? (
        <DescriptionDataSolve
          userID={userID}
          userUUID={userUUID}
          description={description}
          descriptionID={descriptionId}
          descriptionStatus={descriptionStatus}
          descriptionType={descriptionType}
          isPendingDescription={isPendingDescription}
        />
      ) : null}
    </ET3Div>
  );
});

export default Description;
